import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { Ref, onMounted, ref } from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n }  from 'vue-i18n';
import { useStore }   from 'vuex';
import Prog_circular    from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleChart      from '@/components/SmartLink/charts/SingleChart.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL }     from '@/constants/labels';
import { LABELS } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getStatusLogByIP } from '@/services/Smartlink/Graphs';


export default /*#__PURE__*/_defineComponent({
  __name: 'status-log',
  props: {
    ip          : { required:true, type:String },
    typesel     : { required:true, type:String },
    name        : { required:true, type:String },
},
  setup(__props) {

const props = __props;

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store  = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/



const finalTOTArray:Ref<number[][]> = ref([]);

/**
 * 
 */
const showGraphs                     = ref(true);

const params = { ip : props.ip };


/**
 * Captura los valores de la API: 'getStatusLogGraph'
 */
const getData = async () =>{

    const allData = await getStatusLogByIP(params)
    
    if( allData.status === 400 ){
        showGraphs.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showGraphs.value = allData.showGraphs
        finalTOTArray.value = allData.data
    }
    
}

onMounted( async() => {
    getData();
})


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (showGraphs.value)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        class: _normalizeClass([_unref(xs)?'card-dialogs-graph-wop':'card-dialogs-graph', "ma-4 pb-0"]),
        color: "bgtopology"
      }, {
        default: _withCtx(() => [
          (finalTOTArray.value.length !== 0)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "ma-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pa-0 pr-2",
                    "align-self": "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        color: "transparent",
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SingleChart, {
                            name: _unref(STRING_GENERAL).Status,
                            "first-array": finalTOTArray.value,
                            title:  _unref(t)('title.statuLog'),
                            color: "#0E2F5A"
                          }, null, 8, ["name", "first-array", "title"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_sheet, {
                key: 1,
                class: "text-center",
                color: "transparent"
              }, {
                default: _withCtx(() => [
                  _createVNode(Prog_circular)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})